module.exports = __webpack_public_path__ + "img/badge-most-appointment-silver.4f3e3d2d.png";